import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCreditecHref } from '../../../../helpers/creditec';
import LinkButton from '../../../_generic/button/LinkButton';

const CreditecButton = ({ buttonRef }) => {
  const [deal] = useSelector((state) => [state.deals.mainDeal]);
  const [href, setHref] = useState('');

  useEffect(() => {
    if (deal) {
      const getHref = getCreditecHref(deal);
      if (getHref) {
        setHref(getHref);
      }
    }
  }, [deal]);

  return (
    <>
      <div className="cretidtec-button">
        <LinkButton
          aria-label="CHECK ELIGIBILITY"
          buttonRef={buttonRef}
          className="size-xlarger"
          disabled={false}
          href={href}
          isPrimaryStyle
        >
          CHECK ELIGIBILITY
        </LinkButton>
      </div>
      <style jsx>{`
        .cretidtec-button {
          margin-bottom: 15px;
        }
      `}</style>
    </>
  );
};

CreditecButton.propTypes = {
  buttonRef: PropTypes.object,
};

export default CreditecButton;
